import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const ValueOnCustomerView = styled("span")(() => ({
  color: "#9CA6AF",
  font: "400 12px/16px Manrope",
}));

interface ImageListProp {
  hasActionColumn?: boolean;
}
export const ImageList = styled("div")(({ hasActionColumn }: ImageListProp) => ({
  display: "grid",
  gridTemplateColumns: hasActionColumn ? "repeat(6, 1fr)" : "repeat(5, 1fr)",
  gridTemplateAreas: hasActionColumn
    ? '"item qty volume weight total action"'
    : '"item qty volume weight total"',
  alignItems: "center",
  padding: "0 .5rem",
  "& span": {
    "&.item": {
      gridArea: "item",
    },
    "&.qty": {
      gridArea: "qty",
      padding: "10px",
    },
    "&.volume": {
      gridArea: "volume",
      padding: "10px",
    },
    "&.weight": {
      gridArea: "weight",
      padding: "10px",
    },
    "&.total": {
      gridArea: "total",
    },
  },
  "& .action": {
    gridArea: "action",
  },
  "& span:not(:first-child)": {
    textAlign: "center",
  },
  "& .listHeaderItem": {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#465869",
  },
}));

const styles = makeStyles(() => ({
  roomContentItemHeader: {
    borderBottom: "1px solid #CCDEEE",
  },
  roomItemName: {
    fontFamily: "Manrope",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "22px",
    color: "#465869",
  },
  gridItemActions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  gridContainerExpand: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  icon: {
    marginRight: "10px",
    fontSize: "20px",
  },
  containerInputRange: {
    justifyContent: "center",
  },
  gridItem: {
    marginLeft: "20px",
  },
  textInfoRoom: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "#465869",
  },
  roomItemInfo: {
    listStyle: "none",
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& li": {
      margin: 0,
      position: "relative",
      "&:not(:last-child)": {
        paddingRight: "1rem",
        marginRight: "1rem",
        "&:after": {
          content: "''",
          position: "absolute",
          width: 2,
          height: "100%",
          top: 0,
          right: 0,
          backgroundColor: "#CCDEEE",
        },
      },
    },
  },
  roomItemActionButtons: {
    textAlign: "end",
    "& button": {
      fontSize: "20px",
      padding: ".5rem",
    },
  },
  gridList: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gridTemplateAreas: '"item qty volume weight total action"',
    alignItems: "center",
    padding: "0 .5rem",
    "& span": {
      "&.item": {
        gridArea: "item",
      },
      "&.qty": {
        gridArea: "qty",
        padding: "10px",
      },
      "&.volume": {
        gridArea: "volume",
        padding: "10px",
      },
      "&.weight": {
        gridArea: "weight",
        padding: "10px",
      },
      "&.total": {
        gridArea: "total",
      },
    },
    "& .action": {
      gridArea: "action",
    },
    "& span:not(:first-child)": {
      textAlign: "center",
    },
    "& .listHeaderItem": {
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "18px",
      color: "#465869",
    },
  },
  gridListBody: {
    marginTop: "20px",
    "& > div:nth-child(even)": {
      background: "#fff",
    },
  },
  bodyListButtons: {
    textAlign: "end",
    "& button": {
      fontSize: "20px",
      padding: ".5rem",
    },
  },
  input: {
    background: "transparent",
    border: "none",
    borderBottom: "1px solid #f2f2f2",
  },
  ml12: {
    marginLeft: 12,
  },
  containerIconLink: {
    cursor: "help",
    alignItems: "flex-end",
    display: "flex",
  },
  gridListMaterial: { minHeight: "60px" },
}));

export default styles;
